module.exports = __webpack_public_path__ + "img/ctrl-magic-stub-mid-1.764f480b.svg";